import { gql } from '@apollo/client';
const SET_ORDER_SPECIFICATION_VARIANT_ALLOCATION = gql `
  mutation SetOrderSpecificationVariantAllocation(
    $orderId: ID!
    $specificationId: ID!
    $orderComponentVariantId: ID!
    $quantityAllocated: Float!
  ) {
    setOrderSpecificationVariantAllocation(
      orderId: $orderId
      specificationId: $specificationId
      orderComponentVariantId: $orderComponentVariantId
      quantityAllocated: $quantityAllocated
    ) {
      orderComponentVariantId
      allocatedQuantity
      availableQuantity
      collectedQuantity
    }
  }
`;
export default SET_ORDER_SPECIFICATION_VARIANT_ALLOCATION;
